import React from 'react'
import { Checkbox } from 'antd'
import './index.css'

interface FormCheckboxProps {
  Form: any;
  name?: string;
  icon?: React.ReactNode;
  content?: React.ReactNode;
  checked?: boolean;
  disabled?: boolean;
  rules?: any[];
  help?: React.ReactNode;
  onChange?: (e: any) => void;
  formItemStyles?: React.CSSProperties;
  formCheckBoxStyles?: React.CSSProperties;
  customLabelStyles?: React.CSSProperties;
  valuePropName?: string;
  initialValue?: any;
  title?: string;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  Form,
  name,
  icon,
  content = '',
  checked = false,
  disabled = false,
  rules = [],
  help,
  onChange = () => {},
  formItemStyles = {},
  formCheckBoxStyles = {},
  customLabelStyles = {},
  valuePropName = 'checked',
  initialValue = '',
  title = '',
}) => {
  return (
    <Form.Item
      style={formItemStyles}
      valuePropName={valuePropName}
      className=" v2FormCheckbox"
      name={name}
      rules={rules}
      help={help}
      initialValue={initialValue}
      title={title}
    >
      <Checkbox
        style={formCheckBoxStyles}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      >
        <div style={{ display: 'flex', marginLeft: '4px', marginTop: '2px', ...customLabelStyles }}>
          <div role="img" aria-label={content as string} className="radioLabelIcon">
            {icon}
          </div>
          {content}
        </div>
      </Checkbox>
    </Form.Item>
  )
}

export default FormCheckbox
